import { useThemeStore } from '@/lib/stores/themeStore';

export function useModulo() {
  const { mod, setMod } = useThemeStore();
  return { modulo: mod, setModulo: setMod, isEleg: mod === 'eleg', isGab: mod === 'gab' };
}
